import { UploadImgBox } from '@/uikit/Upload'
import { Col, Form, FormInstance, Input, Radio, Row, Select } from 'antd'
import { AnyType } from 'packages/types'
import { useContext } from 'react'
import styled, { css } from 'styled-components'

import { UserPluginContextParam } from '../../utils/type'
import { UserPluginContext, allTagName } from '../../utils/util'

import { SelectScope } from './SelectScope'

/**
 * 编辑推荐应用弹窗 - 弹窗内容
 *
 * @param param - 参数
 * @param param.form - 表单
 * @param param.nostyle - 是否取消外部样式
 * @returns 组件
 */
export const UserPluginContent: React.FC<{
  form: FormInstance<AnyType>
  nostyle?: boolean
}> = ({ form, nostyle }) => {
  const {
    uploadIcon,
    setUploadIcon,
    tags,
    initFormValues,
    scopes,
    exist,
    editPlugin,
    showCard,
    setShowCard,
  } = useContext<UserPluginContextParam>(UserPluginContext)

  const existData = exist ? exist.filter((e) => e.id !== editPlugin?.id) : []

  const uploadIconCallBack = (url: string) => {
    form.setFieldValue('icon', url)
    setUploadIcon(url)
  }
  const deleteIconCallBack = () => {
    form.setFieldValue('icon', '')
    setUploadIcon('')
  }

  return (
    <Box $nostyle={nostyle}>
      <Form
        colon={false}
        form={form}
        layout="vertical"
        initialValues={initFormValues}
      >
        <Row>
          <SectionTitle>{'基本配置'}</SectionTitle>
        </Row>
        <Row>
          <Col
            span={11}
            style={{ paddingBottom: '14px' }}
          >
            <Form.Item
              label="应用名称"
              name="label"
              rules={[
                { required: true, message: '请输入应用名称' },
                { max: 24, message: '字数上限24字' },
                {
                  validator: (rule, value, callback) => {
                    if (value && existData.find((e) => e.label === value)) {
                      callback('名称重复')
                    }
                    callback()
                  },
                },
              ]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              label="应用分类"
              name="tagId"
            >
              <Select placeholder="请选择">
                {tags
                  ?.filter((e) => e.name !== allTagName)
                  .map((e) => (
                    <Select.Option
                      key={e.id}
                      value={e.id}
                    >
                      {e.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="应用简介"
              name="description"
              rules={[{ max: 120, message: '字数上限120字' }]}
            >
              <Input.TextArea
                rows={3}
                placeholder="请输入"
              />
            </Form.Item>
            <StyleFormItem
              label="网页端网址"
              name={['entryUrls', 'web']}
              rules={[
                { required: true, message: '请输入网页端网址' },
                {
                  validator: (rule, value, callback) => {
                    if (
                      value &&
                      existData.find((e) => e.entryUrls?.web === value)
                    ) {
                      callback('网页端网址重复')
                    }
                    if (value && /^http(s)?:/.test(value)) {
                      callback('请输入正确的网址')
                    }
                    callback()
                  },
                },
              ]}
            >
              <Input
                addonBefore={'https://'}
                placeholder="请输入"
              />
            </StyleFormItem>
            <StyleFormItem
              label="移动端网址"
              name={['entryUrls', 'mobile']}
            >
              <Input
                addonBefore={'https://'}
                placeholder="请输入"
              />
            </StyleFormItem>
          </Col>
          <Col span={1} />
          <Col span={12}>
            <Form.Item
              label="应用logo"
              name="icon"
            >
              <UploadImgBox
                uploadSrc={uploadIcon}
                uploadCallBack={uploadIconCallBack}
                deleteCallBack={deleteIconCallBack}
                fileSizeLimit={2}
              />
              <TipText>
                {'请上传JPG/PNG格式、240*240px以上、1:1 、2MB 以内的无圆角图标'}
              </TipText>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <SectionTitle>{'应用范围'}</SectionTitle>
        </Row>
        <Row>
          <Radio.Group
            onChange={(e) => setShowCard(e.target.value === 'selected')}
            defaultValue={scopes.ids.length === 0 ? 'all' : 'selected'}
          >
            <Radio value={'all'}>{'全部成员'}</Radio>
            <Radio value={'selected'}>{'部分成员'}</Radio>
          </Radio.Group>
        </Row>
        <Row>
          <SelectScope showCard={showCard} />
        </Row>
      </Form>
    </Box>
  )
}

const Box = styled.div<{ $nostyle?: boolean }>`
  width: 100%;
  background-color: #fff;
  ${(props) =>
    props.$nostyle
      ? ''
      : css`
          padding: 24px;
          border-radius: 12px;
        `}
`

const SectionTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  height: 28px;
  color: ${(props) => props.theme.text._1};
  margin-bottom: 20px;
`

const TipText = styled.p`
  font-size: 12px;
  line-height: 20px;
  height: 20px;
  margin-top: 8px;
  color: ${(props) => props.theme.text._3};
`

const StyleFormItem = styled(Form.Item)`
  width: 100%;
  &&& {
    .ant-input {
      border-radius: 0 8px 8px 0 !important;
    }
    .ant-input-group-addon {
      padding: 0;
      width: 75px;
    }
  }
`
